import Dashboard from '@/features/Dashboard';
import { FeatureFlag } from '@/services/feature-flags';
import { useFlag } from '@/services/feature-flags/react';
import Button from '@/shared/ui/primitives/Button';

import type { ComponentVariant, PossibleVariants } from './types';

function makeVariants<T extends { [K in PossibleVariants]: ComponentVariant }>(variants: T) {
  return variants;
}

const PersonalizationComponentVariants = (props: any) =>
  makeVariants({
    dashboard_button: {
      A: () => <Button {...props}>Add to dashboard</Button>,
      B: () => null
    },

    dashboard_route_element: { A: () => <Dashboard />, B: () => <Dashboard /> }
  });

// prettier-ignore
const PersonalizationVariantRenderer = <T extends { componentName: PossibleVariants },>({
  componentName,
  ...props
}: T) => {
  const isPersonalizationEnabled = useFlag(FeatureFlag.PersonalizationEnabled);

  const componentVariant = PersonalizationComponentVariants(props)[componentName];

  const Component = (isPersonalizationEnabled ?? false) ? componentVariant.A : componentVariant.B;

  return <Component />;
};

export default PersonalizationVariantRenderer;
